import React from 'react';
import { Carousel } from '../carousel/Carousel';

export const DocumentsModalHeader = ({ documentsList, currentDocumentIndex }) => {
    const titlesList = documentsList.map(document => (
        <h4 key={`heading_${document.dmsDocumentType}`} className={'documents__modal-heading-title'}>
            {document.title}
        </h4>
    ));

    return (
        <div className="documents__modal-heading">
            <Carousel activeIndex={currentDocumentIndex}>{titlesList}</Carousel>
        </div>
    );
};
